import { dateAttrsOf, duplicatesBy, flowAnchors, headerRowFlowAnchors } from './anchors';
import type { DocumentFlowDoc, FlowDate } from './schema';

/** Every date anchor the document holds, in document order, however deeply nested. */
export const flowDateSlots = (doc: DocumentFlowDoc): FlowDate['attrs'][] =>
	dateAttrsOf(flowAnchors(doc));

export const headerRowFlowDateSlots = (doc: DocumentFlowDoc): FlowDate['attrs'][] =>
	dateAttrsOf(headerRowFlowAnchors(doc));

/** Anchors sharing a placement id. The renderer records one box per id, so copies go undated. */
export const duplicateFlowDateSlots = (doc: DocumentFlowDoc): FlowDate['attrs'][] =>
	duplicatesBy(flowDateSlots(doc), (slot) => slot.templateDatePlacementId);
